const routes = [{
  path: '/carspeed', // 测速主页面
  name: 'carspeed',
  component: () => import('@src/modules/account/main'),
  meta: {
    requireAuth: true,
  },
  children: [
    {
      path: '/carspeed/speedConfig',  //车速配置主页面
      name: 'speedConfig',
      component: () => import('@src/modules/carSpeed/view/speedConfig'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/carspeed/speedRecord',  //测速记录主页面
      name: 'speedRecord',
      component: () => import('@src/modules/carSpeed/view/speedRecord'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    }
  ]

}]

export default routes
